import { REQUIRED_FIELDS ,REQUIREDFIELDSBYSTEP} from "./constants";

export const isRequiredField = (fieldName, stepId) => {
  
    // ✅ Step 43 special rules
    if (stepId === 43) {
      if (fieldName === "Material") return true;   // required
      if (fieldName === "Parameter") return false; // not required
      return REQUIRED_FIELDS.includes(fieldName);  // others normal
    }
    if (stepId === 47) {
      if (fieldName === "Build Time") return false; // not required
      return REQUIRED_FIELDS.includes(fieldName);  // others normal
    }
    if (stepId === 39) {
      if (fieldName === "Build Time") return false; // not required
      return REQUIRED_FIELDS.includes(fieldName);  // others normal
    }
    if (stepId === 35) {
      if (fieldName === "Parameter") return false; // not required
      return REQUIRED_FIELDS.includes(fieldName);  // others normal
    }
    // ✅ Other steps use normal rules
    return REQUIRED_FIELDS.includes(fieldName);
  };

// Helper to check if required fields for a step are filled
export const areRequiredFieldsFilled = (formId, formFields) => {
    const requiredKeys = REQUIREDFIELDSBYSTEP[formId] || [];
    
    if (!requiredKeys.length) return true;
    return requiredKeys.every((key) => {
        const value = formFields[key]?.value;
        return value !== undefined && value !== null && value !== 0 && value !== "";
      });
  };
  